import React from 'react';
import PropTypes from 'prop-types';

import { getFormRedirectUrl } from '../../Utils/FormUtils';

import { StyledWrapper, StyledH4, StyledForm, StyledInput, StyledHiddenLabel, StyledMarketingLabel, StyledSocialLoginWrapper, StyledFormSwitcher } from './AccountFormStyles';

var _ref2 = React.createElement(
  StyledH4,
  null,
  'Create Account'
);

var _ref3 = React.createElement('input', { type: 'hidden', name: 'form_type', defaultValue: 'create_customer' });

var _ref4 = React.createElement('input', { type: 'hidden', name: 'utf8', defaultValue: '\u2713' });

var _ref5 = React.createElement(
  StyledHiddenLabel,
  { htmlFor: 'Email' },
  'Email'
);

var _ref6 = React.createElement(StyledInput, {
  type: 'email',
  name: 'customer[email]',
  id: 'Email',
  placeholder: 'Email',
  autoCorrect: 'off',
  autoCapitalize: 'off'
});

var _ref7 = React.createElement(
  StyledHiddenLabel,
  { htmlFor: 'CreatePassword' },
  'Password'
);

var _ref8 = React.createElement(StyledInput, {
  type: 'password',
  name: 'customer[password]',
  id: 'CreatePassword',
  placeholder: 'Password'
});

var _ref9 = React.createElement(
  StyledHiddenLabel,
  { htmlFor: 'ConfirmPassword' },
  'Confirm Password'
);

var _ref10 = React.createElement(StyledInput, {
  type: 'password',
  name: 'ConfirmPassword',
  id: 'ConfirmPassword',
  placeholder: 'Confirm Password'
});

var _ref11 = React.createElement('input', {
  type: 'checkbox',
  name: 'customer[accepts_marketing]',
  defaultValue: 'true'
});

var _ref12 = React.createElement('input', {
  type: 'submit',
  defaultValue: 'Create Account',
  className: 'btn btn--full no-borders gradient-shimmer'
});

var _ref13 = React.createElement(
  StyledSocialLoginWrapper,
  null,
  React.createElement('div', { className: 'one-click-social-login' })
);

var RegisterForm = function RegisterForm(_ref) {
  var toggleAccountForm = _ref.toggleAccountForm,
      isModal = _ref.isModal;

  var redirectUrl = getFormRedirectUrl();

  return React.createElement(
    StyledWrapper,
    { isModal: isModal },
    _ref2,
    React.createElement(
      StyledForm,
      {
        method: 'post',
        action: '/account',
        id: 'create_customer',
        acceptCharset: 'UTF-8',
        noValidate: 'novalidate'
      },
      _ref3,
      _ref4,
      React.createElement('input', { type: 'hidden', name: 'return_to', value: redirectUrl }),
      _ref5,
      _ref6,
      _ref7,
      _ref8,
      _ref9,
      _ref10,
      React.createElement(
        StyledMarketingLabel,
        null,
        _ref11,
        'I\'d love to hear about future deals.'
      ),
      _ref12,
      _ref13
    ),
    React.createElement(
      StyledFormSwitcher,
      {
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'LOGIN' });
        }
      },
      'I Already Have an Account'
    )
  );
};

RegisterForm.propTypes = {
  toggleAccountForm: PropTypes.func.isRequired,
  isModal: PropTypes.bool
};

export default RegisterForm;